import React, { useState, useEffect } from 'react';
import { app } from '@microsoft/teams-js';
import { QueryClient, QueryClientProvider } from 'react-query';
import clsx from 'clsx';
import Routes from './Routes';
import { SnackbarProvider, Toastr } from 'context/SnackbarContext';
import { Provider as FluentProvider, teamsTheme, teamsDarkTheme } from '@fluentui/react-northstar';
import { useCommonContext } from 'context';

function App() {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        retry: 2,
                        refetchOnWindowFocus: false,
                    },
                },
            })
    );
    const { darkTheme, setDarkTheme } = useCommonContext();

    useEffect(() => {
        const initializeApp = async () => {
            await app.initialize();
            const context = await app.getContext();
            setDarkTheme(context.app.theme === 'dark');
            app.notifySuccess();
        };
        initializeApp();
    }, []);

    return (
        <FluentProvider theme={darkTheme ? teamsDarkTheme : teamsTheme}>
            <div className={clsx({ App: true, 'dark-App': darkTheme })}>
                <QueryClientProvider client={queryClient}>
                    <SnackbarProvider>
                        <Toastr />
                        <Routes />
                    </SnackbarProvider>
                </QueryClientProvider>
            </div>
        </FluentProvider>
    );
}

export default App;
